import PropTypes from 'prop-types';
export var youTubeEmbedParams = PropTypes.shape({
  autoplay: PropTypes.oneOf([0, 1]),
  controls: PropTypes.oneOf([0, 1]),
  fs: PropTypes.oneOf([0, 1]),
  iv_load_policy: PropTypes.oneOf([1, 3]),
  loop: PropTypes.oneOf([0, 1]),
  modestbranding: PropTypes.oneOf([0, 1]),
  mute: PropTypes.oneOf([0, 1]),
  playlist: PropTypes.string,
  origin: PropTypes.string,
  playsinline: PropTypes.oneOf([0, 1]),
  rel: PropTypes.oneOf([0, 1])
});
export var youTubeAspectRatio = PropTypes.shape({
  x: PropTypes.number,
  y: PropTypes.number
});